"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultServiceOptions = exports.gluerUniqueFlagValue = exports.gluerUniqueFlagKey = exports.promiseTouchedByModel = exports.promiseDeprecatedFromClonedModel = exports.manualThrownError = exports.promiseDeprecated = void 0;

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

var promiseDeprecated = 'promiseDeprecated';
exports.promiseDeprecated = promiseDeprecated;
var manualThrownError = 'manual thrown error';
exports.manualThrownError = manualThrownError;
var promiseDeprecatedFromClonedModel = 'promiseDeprecatedFromClonedModel';
exports.promiseDeprecatedFromClonedModel = promiseDeprecatedFromClonedModel;
var promiseTouchedByModel = Symbol('promiseTouchedByModel');
exports.promiseTouchedByModel = promiseTouchedByModel;
var gluerUniqueFlagKey = Symbol('gluerUniqueFlagKey');
exports.gluerUniqueFlagKey = gluerUniqueFlagKey;
var gluerUniqueFlagValue = Symbol('gluerUniqueFlagValue');
exports.gluerUniqueFlagValue = gluerUniqueFlagValue;
var defaultServiceOptions = {};
exports.defaultServiceOptions = defaultServiceOptions;